/**
 * Avatares animados (F49): cada classe tem um personagem fixo dos KayKit Adventurers 2.0 (`ClassDef.character`), com
 * os detalhes da roupa (as células de destaque do atlas, máscara `_TINT`) tingidos na cor da classe,
 * como os itens (F47) e os baús (F48). Só visual: ids, colisores, protocolo e regras não mudam.
 */
export const AVATAR_CHARACTERS = ["cavaleiro", "patrulheiro", "barbaro", "ladino", "mago", "ladino-encapuzado"] as const;

export type AvatarCharacter = (typeof AVATAR_CHARACTERS)[number];

export interface AvatarLook {
  readonly character: AvatarCharacter;
  /** Nome do personagem para o jogador (pt-BR). */
  readonly name: string;
}

/** Os personagens do pacote, com o nome que o jogador vê (catálogo; a ordem não é a das classes). */
export const AVATAR_LOOKS: readonly AvatarLook[] = [
  { character: "cavaleiro", name: "Cavaleiro" },
  { character: "patrulheiro", name: "Patrulheiro" },
  { character: "barbaro", name: "Bárbaro" },
  { character: "ladino", name: "Ladino" },
  { character: "mago", name: "Mago" },
  { character: "ladino-encapuzado", name: "Ladino Encapuzado" },
];
